<template>
	<div class="users">
		<vue-snotify></vue-snotify>
        <div class="row">
			<div class="col-md-7">
				<div class="card">
					<div class="card-header">
						<h3 class="card-title">Listado de usuarios</h3>
						<i class="fas fa-sync float-right pointer" @click="getAllUsers"></i>
					</div>
					<!-- /.card-header -->
					<div class="card-body table-sm">
						<table class="table table-bordered table-hover">
							<thead>                  
								<tr>
									<th style="width: 10px">#</th>
									<th>Nombre</th>
									<th>Email</th>
									<th style="width: 40px">Acciones</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in listUsers" class="pointer" @click="initObjectUser(item)" :key="index">
									<td>{{ item.id }}</td>						
									<td>{{ item.name }}</td>						
									<td>{{ item.email }}</td>						
									<td class="text-right">
										<span class="badge bg-warning pointer margin-right5"><i class="fas fa-key" @click="resetPasswordLocal(item)"></i></span>
										<span class="badge bg-danger pointer margin-right5"><i class="far fa-trash-alt" @click="removeListUsers(item)" v-if="item.removable"></i></span>
									</td>					
								</tr>
							</tbody>
						</table>
					</div>
					<div class="card-footer clearfix" v-if="1==0">
						<ul class="pagination pagination-sm m-0 float-right">
							<li class="page-item"><a class="page-link" href="#">&laquo;</a></li>
							<li class="page-item"><a class="page-link" href="#">1</a></li>
							<li class="page-item"><a class="page-link" href="#">2</a></li>
							<li class="page-item"><a class="page-link" href="#">3</a></li>
							<li class="page-item"><a class="page-link" href="#">&raquo;</a></li>
						</ul>
					</div>
				</div>
			</div>
			<div class="col-md-5">
				<div class="card">
					<div class="card-header">
						<h3 class="card-title">
							Datos de usuario
						</h3>
						<i class="fas fa-user-plus float-right pointer text-primary" v-if="objectUser.id !== '0'" @click="clearObjectUser"></i>
					</div>
					<div class="card-body">
						<div class="form-group">
							<label for="inputName">Nombre</label>
							<input type="text" class="form-control form-control-sm" v-model='objectUser.name' placeholder="">
						</div>
						<div class="form-group">
							<label for="inputMail">Email</label>
							<input type="email" class="form-control form-control-sm" v-model='objectUser.email' value="" placeholder="">
						</div>
						<div class="form-group">
							<label for="inputNick">Nick</label>
							<input type="nick" class="form-control form-control-sm" v-model='objectUser.nick' value="" placeholder="">
						</div>
						<div class="alert" :class="(message.success) ? 'alert-success' : 'alert-danger'" role="alert" v-if="message.text !== ''">
							{{ message.text }}
							<ul v-if="!message.success">
								<li v-for="(item, index) in message.data" :key="index">{{ item }}</li>
							</ul>
						</div>
					</div>
					<div class="card-footer clearfix">
						<input @click="saveUser" :value="(objectUser.id == 0)? 'Crear usuario' : 'Guardar cambios'" class="btn btn-sm btn-primary float-right pointer">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import users from '@/mixins/users'

export default {
	name: 'Users',
	mixins: [axiosAction, errors, mixin, users],
	data() {
		return {
			message : {
				text: '',
				success: false,
				data: []
			},
		}
	},
	computed: {
	},
	methods: {
		initModuleLocal() {
			this.setTitleModule('Gestión de usuarios')
			this.setSubTitleModule('')
			this.getAllUsers()
			this.clearObjectUser()
			this.setListening()
		},
		removeListUsers(item) {
			if(confirm('Esta a punto de borrar al usuario "' + item.name + '".\n¿Quiere continuar? ')) {
				this.deleteUser(item.id)
			}
		},
		resetPasswordLocal(item) {
			if(confirm('Se reseteará la contraseña del usuario "' + item.name + '" al valor por omisión del sistema".\n¿Quiere continuar? ')) {
				this.resetPassword(item.id)
			}
		},
		resetPasswordResultLocal(response) {
			if(response.data.success) {
				this.$snotify.success('La contraseña fue reseteada para ' + response.data.data.name, response.data.message)
			}
		},
		setErrorSaveUserLocal(response) {
			this.message.success = response.data.success
			this.message.text = response.data.message
			this.message.data = response.data.data
			setTimeOut(() => { this.messa}, 5000)
		},
		setListening() {
			this.sockets.subscribe('DELETE_USER', (data) => { this.deleteItemListUsers(data.body) })
			this.sockets.subscribe('NEW_USER', (data) => { this.addListUsers(data.body) })
			this.sockets.subscribe('UPDATE_USER', (data) => { this.updateItemListUsers(data.body) })
		}
	},
	components: {
	},
	mounted () {
		this.initModule()
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
